document.addEventListener('DOMContentLoaded', function () {
  // Reveal on scroll
  var toReveal = document.querySelectorAll('.lc-io');
  if (toReveal.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('lc-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    toReveal.forEach(function (el) { io.observe(el); });
  } else {
    toReveal.forEach(function (el) { el.classList.add('lc-in'); });
  }

  // Acordeon (FAQ)
  document.querySelectorAll('[data-lc-acc-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var row = btn.closest('[data-lc-acc-row]');
      var open = row.hasAttribute('data-open');
      row.parentElement.querySelectorAll('[data-lc-acc-row]').forEach(function (r) {
        r.removeAttribute('data-open');
        r.querySelector('[data-lc-acc-btn]').setAttribute('aria-expanded', 'false');
      });
      if (!open) {
        row.setAttribute('data-open', '');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Hotspots (capas del producto)
  document.querySelectorAll('[data-lc-hotspot]').forEach(function (hot) {
    hot.addEventListener('click', function () {
      var panelId = hot.getAttribute('data-lc-hotspot');
      var wasOpen = hot.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-lc-hotspot]').forEach(function (h) { h.setAttribute('aria-expanded', 'false'); });
      document.querySelectorAll('[data-lc-hotspot-panel]').forEach(function (p) { p.hidden = true; });
      if (!wasOpen) {
        hot.setAttribute('aria-expanded', 'true');
        var panel = document.querySelector('[data-lc-hotspot-panel="' + panelId + '"]');
        if (panel) panel.hidden = false;
      }
    });
  });

  // Galeria: miniatura -> foto principal
  document.querySelectorAll('[data-lc-gal-mini]').forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-lc-src');
      var main = document.querySelector('[data-lc-gal-main]');
      if (main && src) main.src = src;
      document.querySelectorAll('[data-lc-gal-mini]').forEach(function (m) { m.classList.remove('is-activa'); });
      mini.classList.add('is-activa');
    });
  });

  // Cuenta atras
  document.querySelectorAll('[data-lc-countdown]').forEach(function (el) {
    var secs = parseInt(el.getAttribute('data-lc-countdown'), 10) || 0;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      if (secs > 0) secs--;
      var h = Math.floor(secs / 3600), m = Math.floor((secs % 3600) / 60), s = secs % 60;
      el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });

  // Buy box: cantidad + packs + barra flotante
  document.querySelectorAll('[data-lc-buybox]').forEach(function (box) {
    var form = box.querySelector('form');
    var qtyInput = box.querySelector('[data-lc-qty-input]');
    var qtyDisplay = box.querySelector('[data-lc-qty-display]');
    var totalEls = box.querySelectorAll('[data-lc-total]');
    var pack1 = box.querySelector('[data-lc-pack1]');
    var pack2 = box.querySelector('[data-lc-pack2]');
    var price = parseFloat(box.getAttribute('data-lc-price')) || 0;
    var currency = box.getAttribute('data-lc-currency') || 'MXN';

    function fmt(n) {
      return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + currency;
    }

    function render() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      var unit = qty >= 2 ? price * 0.75 : price;
      var total = Math.round(unit * qty * 100) / 100;
      if (qtyDisplay) qtyDisplay.textContent = qty;
      totalEls.forEach(function (el) { el.textContent = fmt(total); });
      document.querySelectorAll('[data-lc-fbar] [data-lc-total]').forEach(function (el) { el.textContent = fmt(total); });
      if (pack1) pack1.style.borderColor = qty < 2 ? 'var(--lc-accent)' : 'var(--lc-neutral-300)';
      if (pack2) pack2.style.borderColor = qty >= 2 ? 'var(--lc-accent)' : 'var(--lc-neutral-300)';
    }

    box.querySelectorAll('[data-lc-qty-dec]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        render();
      });
    });
    box.querySelectorAll('[data-lc-qty-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.min(10, (parseInt(qtyInput.value, 10) || 1) + 1);
        render();
      });
    });
    if (pack1) pack1.addEventListener('click', function () { qtyInput.value = 1; render(); });
    if (pack2) pack2.addEventListener('click', function () { qtyInput.value = 2; render(); });

    render();

    // Barra flotante inferior: aparece al pasar la caja de compra, y se
    // oculta de nuevo al llegar al pie de página para no tapar sus enlaces
    // (política de privacidad, etc.).
    var fbar = document.querySelector('[data-lc-fbar]');
    if (fbar) {
      var pieDePagina = document.querySelector('[id$="__footer"]');
      var onScroll = function () {
        var pasoLaCaja = box.getBoundingClientRect().bottom < 0;
        var llegoAlPie = pieDePagina && pieDePagina.getBoundingClientRect().top < window.innerHeight;
        fbar.classList.toggle('lc-show', pasoLaCaja && !llegoAlPie);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var fbarBtn = fbar.querySelector('[data-lc-fbar-submit]');
      if (fbarBtn && form) {
        fbarBtn.addEventListener('click', function () {
          document.getElementById(box.getAttribute('data-lc-buybox')).scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }

    // Enviar al carrito via AJAX y mostrar estado en el boton
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var qty = parseInt(qtyInput.value, 10) || 1;
        var submitBtn = form.querySelector('[data-lc-submit]');
        var formData = new FormData(form);
        formData.set('quantity', qty);
        if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.textoOriginal = submitBtn.textContent; submitBtn.textContent = 'Agregando...'; }
        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (submitBtn) submitBtn.textContent = 'Añadido ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + '?section_id=cart-icon-bubble')
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var bubble = doc.querySelector('#cart-icon-bubble');
                var live = document.querySelector('#cart-icon-bubble');
                if (bubble && live) live.innerHTML = bubble.innerHTML;
              }).catch(function () {});
            setTimeout(function () {
              if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.textoOriginal; }
            }, 1800);
          })
          .catch(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.textoOriginal; }
            alert('No se pudo añadir al carrito. Inténtalo de nuevo.');
          });
      });
    }
  });

  // Reseñas: mini carrusel automatico
  document.querySelectorAll('[data-lc-rev-track]').forEach(function (track) {
    var slides = track.children;
    if (!slides.length) return;
    var i = 0;
    var dotsWrap = document.querySelector('[data-lc-rev-dots="' + track.getAttribute('data-lc-rev-track') + '"]');
    var dots = dotsWrap ? dotsWrap.children : [];
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      Array.prototype.forEach.call(dots, function (d, di) {
        d.style.background = di === i ? 'var(--lc-accent)' : 'var(--lc-neutral-300)';
        d.style.width = di === i ? '20px' : '6px';
      });
    }
    Array.prototype.forEach.call(dots, function (d, di) { d.addEventListener('click', function () { go(di); }); });
    go(0);
    setInterval(function () { go(i + 1); }, 4500);
  });

  // Deja tu reseña: abrir formulario + selector de estrellas
  document.querySelectorAll('[data-lc-review-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var box = btn.closest('[data-lc-review-box]');
      var form = box.querySelector('[data-lc-review-form]');
      if (form) form.hidden = !form.hidden;
    });
  });
  document.querySelectorAll('[data-lc-star-picker]').forEach(function (picker) {
    var input = picker.parentElement.querySelector('[data-lc-star-input]');
    function paint(n) {
      picker.querySelectorAll('[data-lc-star]').forEach(function (s) {
        s.style.color = parseInt(s.getAttribute('data-lc-star'), 10) <= n ? 'var(--lc-gold)' : 'var(--lc-neutral-300)';
      });
    }
    picker.querySelectorAll('[data-lc-star]').forEach(function (star) {
      star.addEventListener('click', function () {
        var n = parseInt(star.getAttribute('data-lc-star'), 10);
        if (input) input.value = n;
        paint(n);
      });
    });
    paint(5);
  });

  // Newsletter (formulario nativo de Shopify)
  document.querySelectorAll('[data-lc-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button');
      if (btn) { btn.disabled = true; btn.textContent = 'Enviando...'; }
    });
  });
});
